export const TOOLTIP_OFFSET_Y = 15 // Tooltip Y offset from target
export const TOOLTIP_OFFSET_X = 15 // Tooltip X offset from target

export const POSITIONS = {
  TOP: 'top',
  LEFT: 'left',
  BOTTOM: 'bottom',
  RIGHT: 'right'
}
